<template class="mx-0 px-0 my-1 py-0">
    <b-card :header="biProductCat" header-tag="header">
        <div
            v-for="(bilijst, index) in bakingredientLijst"
            v-bind:key="bilijst.productID"
        >
            <card-bakingredient-lijst-detail
                class="mx-0 px-0 my-1 py-0"
                v-model="bakingredientLijst[index]"
                :editAllowed="editAllowed"
                :baseDateTime="baseDateTime"
                :newDateTime="newDateTime"
                :preselected="preselected"
                :recipeCatProducts="recipeCatProducts"
                :keyIndex="index"
                @zuurseltijd="set_inputZuurselTijd"
                @changeMilk="recalcMilk"
                @newDateTime="setNewDateTime"
                @change="passChanged"
                @validComponent="passValid"
            />
        </div>
        <h4>
            <b-badge variant="light" v-if="multipleItems && isMilk"
                >{{
                    $t('com_totaal', {
                        ns: 'common'
                    })
                }}
                = {{ biTotaal }}</b-badge
            >
        </h4>
    </b-card>
</template>

<script>
import _ from 'lodash';
import CardBakingredientLijstDetail from './CardBakingredientLijstDetail.vue';
import { INGRCAT_ENUM } from '../../models/IngredientCategorie';
//import { BIlijst } from '../../models/BakInfo_helper';

export default {
    name: 'CardBakingredientLijst',
    data() {
        return {
            aangeraakt: 1,
            validList: [],
            newDateTime: null
        };
    },
    components: {
        CardBakingredientLijstDetail
    },
    model: {
        prop: 'bakingredientLijst',
        event: 'changedLijst'
    },
    props: {
        bakingredientLijst: {
            type: Array,
            required: true
        },
        editAllowed: {
            type: Boolean,
            default: false
        },
        baseDateTime: {
            type: String
        },
        startDateTime: {
            type: String
        },
        preselected: {
            type: Number,
            default: -1
        }
    },
    computed: {
        biProductCat() {
            return this.bakingredientLijst[0].ingredientCategorieNaam;
        },
        isMilk() {
            return (
                this.bakingredientLijst[0].ingredientCategorieID ==
                INGRCAT_ENUM.Melk
            );
        },
        multipleItems() {
            return this.bakingredientLijst.length > 1;
        },
        recipeCatProducts() {
            return this.bakingredientLijst.map((x) => x.productID);
        },
        biTotaal() {
            // eslint-disable-next-line no-unused-vars
            const tel = this.aangeraakt;
            let tot = 0;
            for (let i = 0; i < this.bakingredientLijst.length; i++) {
                const bilijst = this.bakingredientLijst[i];
                const filteredlijst = bilijst.bakIngredienten.filter(
                    (x) =>
                        x.isDeleted == false &&
                        (x.nouse == undefined || x.nouse == false)
                );
                const tempArr = filteredlijst.map((x) => x.hoeveelheid);
                const prodAmount = _.sum(tempArr);
                tot += prodAmount;
            }
            this.passChanged(tot);
            return tot;
        }
    },
    methods: {
        recalcMilk() {
            this.aangeraakt += 1;
        },
        set_inputZuurselTijd(value) {
            let kleinste = null;
            // zoek de laagste toegevoegdTijd in de bakingredientLijsten
            for (let i = 0; i < this.bakingredientLijst.length; i++) {
                for (let j = 0; j < this.bakingredientLijst[i].bakIngredienten.length; j++) {
                    const tijd = this.bakingredientLijst[i].bakIngredienten[j].toegevoegdTijd;
                    if (tijd != undefined) {
                        if (kleinste == undefined || tijd < kleinste) {
                            kleinste = tijd;
                        }
                    }
                }
            }

            if (value <= kleinste) {
                this.$emit('zuurseltijd', value);
            }
        },
        passChanged(value) {
            this.$emit('change', value);
        },
        passValid(obj) {
            // obj = {keyIndex: index, valid: boolean}
            // Update or add the validity for the given keyIndex
            const o = this.validList.find((v) => v.keyIndex === obj.keyIndex);
            if (o === undefined) {
                this.validList.push({
                    keyIndex: obj.keyIndex,
                    valid: obj.valid
                });
            } else {
                o.valid = obj.valid;
            }
            // Check if all items in validList are true (valid)
            const allValid = this.validList.every((v) => v.valid === true);

            // Emit the validity of the component and overall validity
            this.$emit('validComponent', allValid);
            this.$emit('changed', true);
        },
        setNewDateTime(value) {
            this.newDateTime = value;
        }
    },
    created() {
        if (this.startDateTime != undefined) {
            this.newDateTime = this.startDateTime;
        }
    }
};
</script>
